import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/iyde-build/public_html/components/Certificates/Certificates.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/root/iyde-build/public_html/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/root/iyde-build/public_html/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/root/iyde-build/public_html/public/icon/check-circle.svg");
;
import(/* webpackMode: "eager" */ "/root/iyde-build/public_html/public/icon/dot.svg");
;
import(/* webpackMode: "eager" */ "/root/iyde-build/public_html/public/icon/kuryer.svg");
;
import(/* webpackMode: "eager" */ "/root/iyde-build/public_html/public/icon/parfume.svg");
;
import(/* webpackMode: "eager" */ "/root/iyde-build/public_html/public/icon/percent.svg");
;
import(/* webpackMode: "eager" */ "/root/iyde-build/public_html/public/images/about1.jpg");
